"use client";

import { useState } from "react";
import { Check, Link2 } from "lucide-react";
import { IconBrandLinkedin, IconBrandX } from "@tabler/icons-react";

export default function ShareLinks({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  const enc = encodeURIComponent;
  const item =
    "grid h-9 w-9 place-items-center rounded-full border border-lp-rule text-lp-ink-2 transition-colors hover:border-lp-rule-strong hover:text-lp-ink";

  return (
    <div className="flex items-center gap-2">
      <span className="mr-1 text-[13px] text-lp-ink-3">Share</span>
      <button
        type="button"
        className={item}
        aria-label={copied ? "Link copied" : "Copy link"}
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 1800);
          } catch {
            /* clipboard blocked: nothing to do */
          }
        }}
      >
        {copied ? <Check className="h-4 w-4" /> : <Link2 className="h-4 w-4" />}
      </button>
      <a
        className={item}
        aria-label="Share on X"
        target="_blank"
        rel="noopener noreferrer"
        href={`https://x.com/intent/post?text=${enc(title)}&url=${enc(url)}`}
      >
        <IconBrandX className="h-4 w-4" />
      </a>
      <a
        className={item}
        aria-label="Share on LinkedIn"
        target="_blank"
        rel="noopener noreferrer"
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`}
      >
        <IconBrandLinkedin className="h-4 w-4" />
      </a>
    </div>
  );
}
